const EMAIL_MAX_LENGTH = 254;
const LOCAL_MAX_LENGTH = 64;
const DOMAIN_LABEL_MAX_LENGTH = 63;

const LOCAL_PART_RE = /^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+$/;
const DOMAIN_LABEL_RE = /^[A-Za-z0-9-]+$/;
const TLD_RE = /^([A-Za-z]{2,63}|xn--[A-Za-z0-9-]{2,59})$/;

export const normalizeEmail = (value = "") => {
    return String(value).trim();
};

export const isValidEmail = (value = "") => {
    const email = normalizeEmail(value);

    if (!email || email.length > EMAIL_MAX_LENGTH || email.includes(" ")) {
        return false;
    }

    const parts = email.split("@");
    if (parts.length !== 2) {
        return false;
    }

    const [localPart, domainPart] = parts;

    if (!localPart || !domainPart) {
        return false;
    }

    if (localPart.length > LOCAL_MAX_LENGTH) {
        return false;
    }

    if (!LOCAL_PART_RE.test(localPart)) {
        return false;
    }

    if (localPart.startsWith(".") || localPart.endsWith(".") || localPart.includes("..")) {
        return false;
    }

    if (domainPart.includes("..")) {
        return false;
    }

    const labels = domainPart.split(".");
    if (labels.length < 2) {
        return false;
    }

    for (const label of labels) {
        if (!label || label.length > DOMAIN_LABEL_MAX_LENGTH) {
            return false;
        }

        if (!DOMAIN_LABEL_RE.test(label)) {
            return false;
        }

        if (label.startsWith("-") || label.endsWith("-")) {
            return false;
        }
    }

    const tld = labels[labels.length - 1];
    return TLD_RE.test(tld);
};
